<script>
    export let dimension;
    export let position;

    export let _click = () => {};
</script>

<div on:click={_click} on:keypress={()=>{}} class='zone-location-button' style="{dimension}{position}">
</div>

<style lang="scss">
    .zone-location-button{
        position: absolute;
    }
</style>